import axios from '@/utils/axios'
// 列表
export function listUser(query) {
    return axios({
        url: '/video/user/list',
        method: 'get',
        params: query
    })
}
// 添加
export function addUser(query) {
    return axios({
        url: '/video/user/userInfo/save',
        method: 'post',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/video/user/getUserInfo',
        method: 'get',
        params: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/video/user/userInfo/del',
        method: 'post',
        params: query
    })
}
